import ConfigurationEditor from '../configuration/Editor';

export default class ProjectConfigurationEditor extends ConfigurationEditor {
    constructor(props) {
        super(props)
    }

    onFormModelChange() {
        if (this.props.editMode) {
            super.onFormModelChange()
        }
    }
}